<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isActive"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <div class="flex items-center">
        <img width="40" :src="ProductIcon" class="mr-4" />
        <div>
          <h4>Stock product request</h4>
          <small v-if="product">{{ product.name }}</small>
        </div>
      </div>
      <feather-icon icon="XIcon" @click.stop="isActive = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <vs-prompt
      style="z-index: 99999999"
      @accept="confirmDeclineRequest"
      @close="declineRequestPrompt = false"
      @cancel="declineRequestPrompt = false"
      title="Decline request"
      :active.sync="confirmDeclinePrompt"
    >
      <div class="con-exemple-prompt">
        Reason for declining the request
        <vs-textarea placeholder="Reason" v-model="declineComment" />
      </div>
    </vs-prompt>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <Loading v-if="isLoading" />
      <div v-else class="p-6">
        <p class="mb-3" style="font-weight: bold">Request</p>

        <div class="flex flex-col mb-3">
          <div class="mb-1 text-sm">
            <span>Status</span>
          </div>
          <div>
            <vs-chip
              :color="
                productRequest.accepted === null || productRequest.accepted === undefined
                  ? 'primary'
                  : productRequest.accepted
                  ? 'success'
                  : 'danger'
              "
            >
              {{
                productRequest.accepted === null || productRequest.accepted === undefined
                  ? "Awaiting"
                  : productRequest.accepted
                  ? "Accepted"
                  : "Declined"
              }}
            </vs-chip>
          </div>
        </div>

        <div class="flex flex-col mb-3">
          <div class="mb-1 text-sm">
            <span>Requested by</span>
          </div>
          <div>
            <code>{{ productRequest.requestedBy.username }} at {{ productRequest.createdAt | formatDate }}</code>
          </div>
        </div>

        <div class="flex flex-col mb-3">
          <div class="mb-1 text-sm">
            <span>Requester product link</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="productRequest.productLink" />
          </div>
        </div>

        <div class="flex flex-col">
          <div class="mb-1 text-sm">
            <span>Requester comment</span>
          </div>
          <div>
            <vs-textarea class="w-full" v-model="productRequest.requesterComment" />
          </div>
        </div>

        <vs-divider />
        <p class="mb-3" style="font-weight: bold">Product</p>

        <vs-row>
          <vs-col vs-w="6" class="flex flex-col mb-2">
            <div class="mb-1 text-sm">
              <span>Product number</span>
            </div>
            <div>
              <div>
                <vs-input class="w-full" v-model="product.number" />
              </div>
            </div>
          </vs-col>
        </vs-row>

        <div class="flex flex-col mb-3">
          <div class="mb-1 text-sm">
            <span>Name</span>
          </div>
          <div>
            <vs-input class="w-full" v-model="product.name" />
          </div>
        </div>

        <div class="flex flex-col mb-3">
          <div class="mb-1 text-sm">
            <span>Country</span>
          </div>
          <div>
            <vs-select v-model="product.countryId" class="w-4/5" autocomplete>
              <vs-select-item :key="index" :value="item.countryId.id" :text="item.name" v-for="(item, index) in countries" />
            </vs-select>
          </div>
        </div>

        <div class="flex flex-col mb-3">
          <div class="mb-1 text-sm">
            <span>Category</span>
          </div>
          <div class="flex">
            <vs-select v-model="product.productCategoryId" class="w-4/5" autocomplete>
              <vs-select-item
                :key="index"
                :value="item.productCategoryId.id"
                :text="item.name"
                v-for="(item, index) in productCategories"
              />
            </vs-select>
          </div>
        </div>

        <div class="flex flex-col mb-3">
          <div class="mb-1 text-sm">
            <span>VAT rate</span>
          </div>
          <div class="flex">
            <vs-select v-model="product.taxGroupId" class="w-4/5" autocomplete>
              <vs-select-item :key="index" :value="item.id" :text="item.code" v-for="(item, index) in taxGroups" />
            </vs-select>
          </div>
        </div>

        <div class="flex flex-col mb-3">
          <div class="mb-1 text-sm">
            <span>Vendor</span>
          </div>
          <div class="flex">
            <vs-select v-model="product.vendorId" class="w-4/5" autocomplete>
              <vs-select-item :key="index" :value="item.vendorId.id" :text="item.name" v-for="(item, index) in vendors" />
            </vs-select>
          </div>
        </div>

        <div class="flex flex-col mb-3">
          <div class="mb-1 text-sm">
            <span>Alternative vendors</span>
          </div>
          <div class="flex">
            <vs-select v-model="product.alternativeVendorIds" class="w-4/5" autocomplete multiple>
              <vs-select-item :key="index" :value="item.vendorId.id" :text="item.name" v-for="(item, index) in vendors" />
            </vs-select>
          </div>
        </div>

        <vs-row>
          <vs-col vs-w="6" class="flex flex-col mb-2">
            <div class="text-sm">
              <span>Unit price</span>
            </div>
            <div>
              <div class="flex">
                <vs-input-number v-model="product.unitPrice" :step="0.05" />
              </div>
            </div>
          </vs-col>

          <vs-col vs-w="6" class="flex flex-col mb-2">
            <div class="text-sm">
              <span>Unit amount</span>
            </div>
            <div>
              <div class="flex items-center">
                <div class="flex inline-block">
                  <vs-input-number :min="0" :step="1" v-model="product.itemQuantity" />
                </div>
                <div class="ml-2">
                  <vs-select width="74px" v-model="product.itemMeasurementUnit">
                    <vs-select-item :key="unit.id" :value="unit.id" :text="unit.name" v-for="unit in units" />
                  </vs-select>
                  <!-- {{ tr.unit }} -->
                </div>
              </div>
            </div>
          </vs-col>

          <vs-col vs-w="6" class="flex flex-col mb-2">
            <div class="text-sm">
              <span>Case size</span>
            </div>
            <div>
              <div class="flex">
                <vs-input-number v-model="product.caseSize" :step="1" />
              </div>
            </div>
          </vs-col>
        </vs-row>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid || !isAwaitingStatus"> Accept and create </vs-button>
      <vs-button color="danger" @click="declineRequest" :disabled="!isAwaitingStatus"> Decline</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import ProductIcon from "@/assets/images/shout-icon.png";
import { mapGetters } from "vuex";

export default {
  components: {
    VuePerfectScrollbar
  },
  data() {
    return {
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      ProductIcon,

      isActive: false,
      isLoading: true,

      product: null,
      productRequest: null,
      confirmDeclinePrompt: false,
      declineComment: ""
    };
  },
  computed: {
    ...mapGetters({
      taxGroups: "taxGroups/taxGroups",
      units: "units/units",
      vendors: "vendors/vendors",
      countries: "countries/countries",
      productCategories: "productCategories/productCategories"
    }),
    isAwaitingStatus() {
      return this.productRequest && (this.productRequest.accepted === null || this.productRequest.accepted === undefined);
    },
    isFormValid() {
      if (!this.product) return false;
      if (!this.product.name) return false;
      if (!this.product.countryId) return false;
      if (!this.product.productCategoryId) return false;
      if (!this.product.vendorId) return false;

      return true;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    }
  },
  methods: {
    async show(stockProductId) {
      this.isActive = true;
      this.isLoading = true;
      var result = await this.$store.dispatch("stockProductRequests/get", stockProductId);

      this.productRequest = result;

      this.product = {
        number: "",
        name: result.stockProductInformation.name,
        vendorId: result.stockProductInformation.vendorIdentifier.vendorId.id,
        countryId: result.stockProductInformation.country.countryId.id,
        alternativeVendorIds: result.stockProductInformation.alternativeVendors.map(e => e.vendorId.id),
        productCategoryId: result.stockProductInformation.productCategoryIdentifier.productCategoryId.id,
        taxGroupId: null,
        basedOnStockProductRequestId: this.productRequest.id,
        caseSize: result.stockProductInformation.caseSize,
        unitPrice: result.stockProductInformation.unitPrice,
        inactive: true,

        itemQuantity: result.stockProductInformation.quantity ? result.stockProductInformation.quantity.amount : 0,
        itemMeasurementUnit: result.stockProductInformation.quantity ? result.stockProductInformation.quantity.unit : "cl"
      };

      await this.loadExternalData();
      console.log("Product?", this.product, this.product.ve);
      this.isLoading = false;
    },

    async loadExternalData() {
      await Promise.all([
        // this.$store.dispatch("countries/getCountries"),
        this.$store.dispatch("vendors/getVendors"),
        this.$store.dispatch("units/getUnits"),
        this.$store.dispatch("productCategories/getProductCategories"),
        this.$store.dispatch("taxGroups/getTaxGroups")
      ]);
    },

    async declineRequest() {
      this.confirmDeclinePrompt = true;
    },
    async confirmDeclineRequest() {
      const dto = {
        comment: this.declineComment
      };

      const result = await this.$store.dispatch("stockProductRequests/decline", {
        id: this.productRequest.id,
        dto: dto
      });
      console.log("Decline result", result);

      await new Promise(resolve => setTimeout(resolve, 2000)); // FIXME - Wait for backend to update

      this.$vs.notify({
        title: "Request declined",
        text: "The stock product request was declined."
      });

      await this.$store.dispatch("stockProductRequests/getAll");

      this.product = null;
      this.productRequest = null;
      this.isActive = false;
      this.isLoading = true;
      this.declineComment = "";
    },
    async submitData() {
      console.log("Submitting DTO", this.product);

      var result = await this.$store.dispatch("stockProducts/createStockProduct", {
        stockProductDto: this.product
      });

      await new Promise(resolve => setTimeout(resolve, 2000)); // FIXME - Wait for backend to update

      await this.$store.dispatch("stockProductRequests/getAll");

      if (result) {
        this.$vs.notify({
          title: "Request accepted",
          text: "Request accepted and stock product created."
        });
      } else {
        this.$vs.notify({
          title: "Error",
          text: "Failed to accept request."
        });
      }

      this.product = null;
      this.productRequest = null;
      this.isActive = false;
      this.isLoading = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>